import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';

class Overlay extends Component {
  render() {
    const { overlay } = this.props;

    if (overlay.open) {
      return (
        <div className={styles.wrapper}>
          {React.createElement(overlay.component, { ...this.props.overlay })}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(state => {
  return { overlay: state.overlay };
})(Overlay);



// WEBPACK FOOTER //
// ./src/components/util/overlay/index.js